/**
 * Content for LeafPerfBonusScale component.
 *
 * This file consolidates legend labels from different sources (Performance Income Dashboard, SSI, etc.)
 * so callers only need to pass a key, and the component handles translation internally.
 */

const content: { [key: string]: any } = {
  legend: {
    // Performance Income Dashboard legend labels
    bfi: "BFI GPV Target",
    bbi: "BBI GPV Target",
    sp: "SP Month",
    maximizeLeadership: "Maximize Leadership Bonus",

    // SSI V2 target label (shared across all tiers)
    ssiTarget: "{amount} Target",
  },
  expandBonusScale: "Expand bonus scale",
  collapseBonusScale: "Collapse bonus scale",
};

export default content;
